import angular from 'angular'
import byFavoritesComponent from './by-favorites.component'
import byFavoritesConfig from './by-favorites.config'
import ByFavoritesController from './by-favorites.controller'
import ByFavoritesService from './by-favorites.service'

let byFavorites = angular.module('app.byFavorites', [])
  .component('byFavorites', byFavoritesComponent)
  .controller('ByFavoritesController', ByFavoritesController)
  .service('ByFavoritesService', ByFavoritesService)
  .config(byFavoritesConfig)

export default byFavorites



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/fast-purchase/by-favorites/by-favorites.js
 **/